<span *ngIf="!!type; else genericDeviceError" [ngClass]="cssClass">
	{{ type }}
</span>
<ng-template #genericDeviceError>
	<sdp-icon [icon]="errorIcon" matTooltip="{{ 'generic.deviceType.error.notfound' | translate }}"></sdp-icon>
</ng-template>